import Masonry from "masonry-layout";

(function($) {
    $(window).on('load', function() {

        /**
         * Fix nav on desktop
         */
        if ($(window).width() > 640) {
          var nav_height = $('#main-nav').outerHeight();
          $('#wrapper-navbar').css({'padding-top': nav_height + 'px'});
          $('#main-nav').addClass('fixit');

          // $(window).on('scroll', function() {
          //   if ($(window).scrollTop() > 0) {
          //     $('#main-nav').addClass('fixit');
          //     $('body').css({'padding-top': nav_height + 'px'});
          //   } else {
          //     $('#main-nav').removeClass('fixit');
          //     $('body').css({'padding-top': '0px'});
          //   }
          // });
        }
        
        /**
         * Check if the page has any `splide` slider instances
         */
        if ($('.testimonials-slider').length) {
            let testimonials = new Splide(".testimonials-slider", {
                type: "loop",
                pagination: false,
                arrows: false,
                breakpoints: {
                  640 : {
                    arrows: true
                  }
                }
              });
              testimonials.mount();

              $(".testimonials-controls.custom-slider-controls > .arrow-left").on(
                "click",
                function (e) {
                  e.preventDefault();
                  testimonials.go("-1");
                }
              );

              $(".testimonials-controls.custom-slider-controls > .arrow-right").on(
                "click",
                function (e) {
                  e.preventDefault();
                  testimonials.go("+1");
                }
              );
        }


        /**
         * Check if the page has any `splide` slider instance for clientele
         */
        if ($('.clients-slider').length) {
            let our_clients = new Splide(".clients-slider", {
                type: "loop",
                pagination: false,
                arrows: false,
                perPage: 5,
                breakpoints: {
                  640: {
                    perPage: 1,
                    arrows: true
                  }
                }
              });
            our_clients.mount();
        }

        /**
         * Contact form floating labels
         */
        if ($('.wpcf7-form').length) {
            $(".wpcf7-form input, .wpcf7-form textarea").focus(function() {
                    $(this).parent().siblings('label').addClass('has-value');
            })
            // blur input fields on unfocus + if has no value
            .blur(function() {
                var text_val = $(this).val();
                if(text_val === "") {
                    $(this).parent().siblings('label').removeClass('has-value');
                }
            });
        }


    /**
     * Blog filters
     */
    if ($(".is-filter").length) {
      let tax = $(".is-filter").data("tax");
      // let filters = $(".is-filter").find(".custom-options > .custom-option");

      const makeXHR = (filterVals = []) => {
        console.log("Hey there", filterVals)
        let data = {
          categoryfilter: filterVals.join(),
          action: "bw_filter",
        };

        tax ? (data.tax = tax) : "";

        $.ajax({
          url: bw_loadmore ? bw_loadmore.ajaxurl : '',
          data: data,
          type: "POST",
          beforeSend: function (xhr) {
            $(".theme-loader").fadeIn("fast");
            $("#projects_results").fadeTo(300, 0.5);
          },
          success: function (res) {
            let data = JSON.parse(res);

            $(".theme-loader").fadeOut("fast");
            $("#projects_results").fadeTo(300, 1);
            $("#projects_results").html(data.content);

            bw_loadmore.current_page = 1;
            bw_loadmore.posts = data.posts;
            bw_loadmore.max_page = data.max_page;

            // hide load more button, if there are not enough posts for the second page
            if (data.max_page < 2) {
              $(".theme_loadmore").hide();
            } else {
              $(".theme_loadmore").show();
            }
          },
        });
      };

      makeXHR();

      $("select.is-filter").on("change", function (e) {
        let filterVals = [];
        filterVals.push($(this).val());
        makeXHR(filterVals);
      });
    }

    /**
     * Load more
     */
    $(document).on("click", ".theme_loadmore", function () {
      let canBeLoaded = true,
        button = $(this),
        tax = $(this).data("tax");
      let data = {
        action: "loadmore",
        query: bw_loadmore.posts,
        page: bw_loadmore.current_page,
        tax,
      };

      $.ajax({
        url: bw_loadmore.ajaxurl,
        data: data,
        type: "POST",
        beforeSend: function (xhr) {
          // you can also add your own preloader here
          // you see, the AJAX call is in process, we shouldn't run it again until complete
          canBeLoaded = false;
          $(".nnn-loader").fadeIn("fast");
          $("#projects_results").fadeTo(300, 0.5);
        },
        success: function (data) {
          if (data) {
            $(".nnn-loader").fadeOut("fast");
            $("#projects_results").append(data);
            $("#projects_results").fadeTo(300, 1);
            bw_loadmore.current_page++;

            if (bw_loadmore.current_page == bw_loadmore.max_page)
              button.hide();
          } else {
            button.show();
          }
        },
      });
    });

    /**
     * Scroll to section
     */
    $(document).on('click', '.scroll-content-btn > a', function(e) {
      e.preventDefault();
      var target = $(this).attr('href');
      $('html, body').animate({ scrollTop: $(target).offset().top});
    })

    /**
     * Go to top
     */
    var btn = $('#gototop');
    $(window).on("scroll", function() {
      if ($(window).scrollTop() > 300) {
        btn.fadeIn();
      } else {
        btn.fadeOut();
      }
    });
    
    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '300');
    });

    /**
     * Custom close button for mobile nav
     */
    if ($(window).width() < 640) {
      $('body').append('<div class="close-btn"></div>');
      $(document).on('click', '.close-btn', function(e) {
        e.preventDefault();
        $("#mega-toggle-block-0").trigger('click');
      })
    }
    

    })
})(jQuery)